<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <figure class="figureimg">
                                        <img :src="robot.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8 col-md-6">
                                    <h3 class="fw-bold">{{ robot.name }}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="robot.risk_level == 3"
                                                    class="badge badge-danger">HIGH</span>
                                                <span v-else-if="robot.risk_level == 2"
                                                    class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="robot.risk_level == 1"
                                                    class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="robot.trade_report_file" target="_blank">
                                                    <i class="fas fa-file" v-if="robot.trade_report_file !== null"></i><span v-else>-</span>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Strategy</p>
                                            <p class="text" v-html="details[0] ? details[0] : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Description</p>
                                            <p class="text" v-html="description ? description : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Type</p>
                                            <p class="text">
                                                {{ robot.type ? robot.type : '-' }}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Lot Size</p>
                                            <p>
                                                <span v-for="(lot, index) in lotSizes" :key="index"
                                                    class="badge bg-dark me-1">{{ lot ? `${lot.lot}%` : '-' }}</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Active Pair</p>
                                            <div v-if="active_pairs.length >= 1" class="col-start-1 d-flex gap-2">
                                                <p v-for="(pair, index) in active_pairs" :key="index">
                                                    {{ pair ? index === active_pairs.length - 1 ? `${pair.active_pair}`
                                                        :
                                                        `${pair.active_pair},` : '-' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Pair Option</p>
                                            <p v-if="pair_options.length >= 1">
                                                <span v-for="(pair, index) in pair_options" :key="index"
                                                    class="badge bg-dark me-1">{{ pair.symbol ? pair.symbol :
                                                        '-' }}</span>
                                            </p>
                                            <p v-else>
                                                <span class="badge bg-dark me-1">'-'</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Price</p>
                                            <p class="text" v-if="robot.selling_price">
                                                Rp {{ new
                                                    Intl.NumberFormat('id-ID').format(Number(parseInt(robot.selling_price)).toFixed())
                                                }}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!robot.selling_price">
                                                Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Artkey Price</p>
                                            <p class="text" v-if="artKey">
                                                Rp {{ new
                                                    Intl.NumberFormat('id-ID').format(Number(parseInt(artKey)).toFixed()) }}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!artKey">
                                                Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{ robot.updated_at |
                                                    moment }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <p>
                                            robot's trading history report
                                            <a :href="robot.trade_report_url" class="text-decoration-none"
                                                target="_blank" rel="noopener noreferrer">Here</a> or
                                            <a :href="robot.trade_report_file" class="text-decoration-none"
                                                target="_blank" rel="noopener noreferrer">Download</a>
                                        </p>
                                        <div class="d-flex justify-content-beetwen my-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" value=""
                                                    v-model="checked" id="flexCheckDefault">
                                                <label class="form-check-label" for="flexCheckDefault">
                                                    I have read the details and willing to proceed
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-lg-8">
                                            <div class="">
                                                <div class="d-block d-md-flex align-items-center">
                                                    <button type="button" @click="verificationUser(robot)"
                                                        :disabled="!checked && !loading"
                                                        class="btn btn_red me-2 flex-1 d-flex align-items-center justify-content-center gap-2"
                                                        data-toggle="modal" data-target="#chooseRobot">
                                                        Continue To Broker Selection
                                                        <div v-if="loading" class="spinner-border text-light me-2"
                                                            role="status"
                                                            style="width: 2rem; height: 25px; width: 25px;"></div>
                                                    </button>
                                                    <router-link class="btn btn-outline-secondary"
                                                        style="padding: 14px;" to="/my-products/robots">Back to
                                                        Products</router-link>
                                                </div>
                                                <!-- <router-link :to="robot.id+'/broker/'" class="btn btn_red">Choose Robot</router-link> -->

                                                <!-- Modal -->
                                                <div v-if="userVerificationStats" class="modal fade" id="chooseRobot"
                                                    data-backdrop="static" data-keyboard="false" tabindex="-1"
                                                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                                    <div class="modal-dialog modal-dialog-centered">
                                                        <div class="modal-content">
                                                            <div class="modal-body">
                                                                <button type="button" class="close" data-dismiss="modal"
                                                                    aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                                <!-- <div class="text-center">
                                                                    <img src="../assets/not-available.svg" width="200" class="mb-3" alt="">
                                                                    <h3 class="title">{{robotName}}</h3>
                                                                    <p>This feature is not yet available!</p>
                                                                </div> -->
                                                                <div class="text-center">
                                                                    <h3 class="title">{{ robotName }}</h3>
                                                                    <p>Are you sure to choose this robot?</p>
                                                                </div>

                                                                <div class="alert alert-danger" v-if="message">
                                                                    {{ message }}
                                                                </div>

                                                                <form @submit.prevent="handleProduct()">
                                                                    <input type="hidden" v-model="product.investor_id"
                                                                        class="form-control" readonly>
                                                                    <input type="hidden" v-model="product.product_id"
                                                                        class="form-control" readonly>
                                                                    <input type="hidden" v-model="product.product_type"
                                                                        class="form-control" readonly>
                                                                    <div class="mb-3">
                                                                        <label for="lotSize">Lot Size <span
                                                                                class="text-danger">*</span></label>
                                                                        <!-- <multiselect v-model="product.lot_size" :multiple="true"
                                                                        :options="lotSizes"></multiselect> -->
                                                                        <select class="form-select" id="lotSize"
                                                                            v-model="product.lot_size"
                                                                            aria-label="Lot Size">
                                                                            <option selected disabled>Choose Lot Size
                                                                            </option>
                                                                            <option v-for="(lot, index) in lotSizes"
                                                                                :value="lot" :key="'lot' + index">{{ lot
                                                                                    ?
                                                                                    `${lot.lot}%` : '-' }}
                                                                            </option>
                                                                        </select>
                                                                        <small class="text-danger">the smaller lot size
                                                                            you choose, the lower your trading
                                                                            risk*</small>
                                                                        <div class="text-danger"
                                                                            v-if="submitted && product.lot_size == ''">
                                                                            Lot Size is required.</div>
                                                                    </div>
                                                                    <div class="mb-3">
                                                                        <label for="activePair">Active Pair <span
                                                                                class="text-danger">*</span></label>
                                                                        <select class="form-select" id="activePair"
                                                                            v-model="product.active_pair"
                                                                            aria-label="Active Pair">
                                                                            <option selected disabled>Choose Active Pair
                                                                            </option>
                                                                            <option
                                                                                v-for="(pair, index) in active_pairs"
                                                                                :key="index">
                                                                                {{ pair ? pair.active_pair : '-' }}
                                                                            </option>
                                                                            <!-- <option>SINGLE</option>
                                                                            <option>DOUBLE</option> -->
                                                                        </select>
                                                                        <div class="text-danger"
                                                                            v-if="submitted && product.active_pair == ''">
                                                                            Active Pair is required.</div>
                                                                    </div>
                                                                    <div class="mb-3">
                                                                        <label for="pairOptions">Pair Options <span
                                                                                class="text-danger">*</span></label>
                                                                        <multiselect id="pairOptions" v-model="options"
                                                                            :multiple="product.active_pair != 'SINGLE' ? true : false"
                                                                            :options="pair_options"
                                                                            :close-on-select="false"
                                                                            :clear-on-select="false" label="symbol"
                                                                            track-by="symbol" placeholder=""
                                                                            @select="onSelect">
                                                                            <template #selection="{ values, isOpen }">
                                                                                <span class="multiselect__single"
                                                                                    v-if="values.length"
                                                                                    v-show="!isOpen">{{ values.length }}
                                                                                    options selected</span>
                                                                            </template>
                                                                        </multiselect>
                                                                        <!-- <select class="form-select" id="pairOptions" v-model="product.pair_option" aria-label="Pair Option">
                                                                            <option selected disabled>Choose Pair Options</option>
                                                                            <option>Forex Major</option>
                                                                            <option>Forex Minor</option>
                                                                            <option>Forex Exotic</option>
                                                                            <option>Index</option>
                                                                            <option>Stock</option>
                                                                            <option>Comodity</option>
                                                                        </select> -->
                                                                        <div class="text-danger"
                                                                            v-if="submitted && options.length == 0">Pair
                                                                            Options is required.</div>
                                                                    </div>
                                                                    <div class="mb-3">
                                                                        <label for="investorNote"
                                                                            class="form-label">Additional Note</label>
                                                                        <textarea class="form-control" id="investorNote"
                                                                            rows="3"
                                                                            v-model="product.investor_note"></textarea>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-12 col-lg-8 mx-auto">
                                                                            <div
                                                                                class="text-center button d-flex align-items-center justify-content-center">
                                                                                <button type="button"
                                                                                    class="btn btn_grey m-2"
                                                                                    data-dismiss="modal"
                                                                                    @click="closeModal">No</button>
                                                                                <button type="submit"
                                                                                    class="btn btn_red m-2 d-flex align-items-center justify-content-center"
                                                                                    :disabled="loading">
                                                                                    <div v-if="loading"
                                                                                        class="spinner-border text-light me-2"
                                                                                        role="status"></div>
                                                                                    <span>Yes, I'm sure</span>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <dash-footer></dash-footer> -->
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import $ from 'jquery'
import moment from "moment";
import swal from "sweetalert"
import Multiselect from 'vue-multiselect'
import Vue from "vue";

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        Multiselect
    },
    data() {
        return {
            user_id: localStorage.getItem('user_id'),
            robot: [],
            artKey: 0,
            robotName: '',
            checked: false,
            loading: false,
            submitted: false,
            userVerificationStats: true,
            message: '',
            details: [],
            active_pairs: [],
            pair_options: [],
            options: [],
            description: '',
            robotType: '',
            expStrategy: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolor, officiis.;<Description here>;<Robot Type Here>;<Lot Size Here>;<Active Pair Here>;<Pair Option Here>',
            product: {
                investor_id: '',
                // broker_account_id : '',
                product_id: '',
                product_type: '',
                lot_size: '',
                active_pair: '',
                pair_option: '',
                investor_note: '',
                // payment_amount : '',
                // currency : '',
                // status : '',
            },
            lotSizes: [],
        }
    },
    async mounted() {
        await axios.get(`investor/robot/${this.$route.params.id}`)
            .then(response => {
                // console.log('Robot All: ', response.data.data)
                this.robot = response.data.data
            }).catch(() => {
                // console.log('Error Robot: ', err.response)
            })
        await axios.get(`artkey/price/`)
            .then(response => {
                this.artKey = response.data.data.selling_price
            }).catch(() => {
                // console.log('Error Robot: ', err.response)
            })

        var token = localStorage.getItem('access_token')
        await axios.get(`investor/${localStorage.user_id}/`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.data.data.investor_verification_status !== null) {
                    const userStats = response.data.data.investor_verification_status
                    if (userStats == 'VERIFIED') {
                        this.userVerificationStats = true
                    } else {
                        this.userVerificationStats = false
                    }
                    // this.userVerificationStats = response.data.data.investor_verification_status
                } else {
                    this.userVerificationStats = ''
                }
            }).catch((err) => {
                console.log(err.response);
            })

        this.details = this.robot.strategy.split(';');
        this.active_pairs = this.robot.active_pairs.map(pair => pair)
        this.pair_options = this.robot.pair_options.map(pair => pair)
        this.lotSizes = this.robot.lot_sizes.map(pair => pair)
        this.description = this.robot.description
        this.robotType = this.robot.robot_type
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    methods: {
        onSelect() {
            if (this.options.length > 1 && this.product.active_pair == 'SINGLE') {
                this.options.pop() // Remove the last selected option to maintain only two selections
            }
            if (this.options.length > 2 && this.product.active_pair == 'DOUBLE') {
                this.options.pop() // Remove the last selected option to maintain only two selections
            }
        },

        checkPair() {
            if (this.options.length < 2 && this.product.active_pair == 'DOUBLE') {
                throw this.message = 'Please select two options'
            }
            if (this.options.length < 2 && this.product.active_pair == 'MULTI') {
                throw this.message = 'Please select at least two options'
            } else {
                this.message = ''
            }
        },
        verificationUser(robot) {
            this.loading = true;
            if (!this.userVerificationStats) {
                this.alertErrorMessage('Your account is not verified yet by our team', 'OK')
            } else {
                this.robotName = robot.name
            }

            this.loading = false;
        },
        handleProduct() {
            this.checkPair()
            this.submitted = true
            if (
                this.product.lot_size !== '' &&
                this.product.active_pair !== '' &&
                (this.options.length > 0 || this.options.length != '')
            ) {
                if (this.message === "") {
                    Vue.swal
                        .fire({
                            title: "Are you sure want to submit?",
                            text: "selected data will be save!",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#000000",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes",
                        })
                        .then(async (res) => {
                            if (res.isConfirmed) {
                                this.loading = true
                                let lotSize = this.product.lot_size.lot ? this.product.lot_size.lot + '%' : 'default'
                                let activePair = this.product.active_pair ? this.product.active_pair : 'default'
                                let pairOption = this.options && this.options.length > 1 ? `(${this.options.map(option => option.symbol).join(', ')})` : this.options.symbol;
                                let additionalNote = this.product.investor_note ? this.product.investor_note : '-'

                                // store active and pair option
                                localStorage.setItem('lotSize', lotSize);
                                localStorage.setItem('activePair', activePair);
                                localStorage.setItem('pairOption', pairOption);
                                let investorNote = 'Besaran Lot: ' + lotSize + ', Pair Aktif: ' + activePair + ', Pair Pilihan: ' + pairOption + ', Catatan: ' + additionalNote

                                let data = new FormData()
                                data.append('investor_id', this.user_id)
                                // data.append('broker_account_id', this.broker.id)
                                data.append('product_id', this.robot.id)
                                data.append('product_type', 'ROBOT')
                                data.append('investor_note', investorNote)

                                await axios.post(`transaction/robot-checkout/`, data)
                                    .then((response) => {
                                        // console.log(response);
                                        this.loading = false
                                        this.submitted = false
                                        $('#chooseRobot').modal('hide')
                                        // window.open('https://bithouse.id', '_blank')
                                        localStorage.setItem('transaction_id', response.data.data.id)
                                        this.$router.push(`${this.robot.id}/broker/`)
                                    }).catch((err) => {
                                        console.log(err);
                                        this.loading = false
                                        this.message = err.data.message
                                        // console.dir(err)
                                        this.loading = false
                                    })
                            }
                        })

                }
            } else {
                // this.product.lot_size = ''
                // this.product.active_pair = ''
                // this.options = []
                this.loading = false
            }

        },
        alertErrorMessage(message, textButton) {
            swal('Opps... Something wrong', `${message}`, 'error', {
                button: {
                    textButton: `${textButton}`,
                },
                dangerMode: true,
            }).then(() => {
                this.loading = false
                this.submitdata = false
            })
        },
        closeModal() {
            this.product.lot_size = ''
            this.product.active_pair = ''
            this.options = []
        },
    }
}
</script>
<style scoped>
.figureimg {
    height: max-content !important;
}

@media (max-width: 500px) {
    .figureimg {
        max-height: 240px !important;
        overflow-y: hidden;
    }
}
</style>
<style>
.content-wrapper .modal .title {
    color: var(--red);
    font-weight: 700;
}

.content-wrapper {
    background: transparent !important;
}

.card.available-robot__card {
    border-radius: 25px;
}

.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}

.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}

.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}

button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}

.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}
</style>
